<div class="comprador-historico">
    <div class="card card-default">
        <div class="card-header">
            <div class="mb-3 form-group">
                <label>{{ 'buyer.pedidos.historico.titulo' | translate}}</label>
                <form class="d-flex flex-row align-items-center flex-wrap">
                    <div class="col-md-2">
                        <div class="input-group">
                            <select class="form-select" name="filtroStatus" [(ngModel)]="filtroStatus">
                                <option value="0" selected>{{ 'buyer.pedidos.filtro.situacao.opcoes.todos' | translate}}</option>
                                <option value="1">{{ 'buyer.pedidos.filtro.situacao.opcoes.em-analise' | translate}}</option>
                                <option value="2">{{ 'buyer.pedidos.filtro.situacao.opcoes.aguardando-entrega' | translate}}</option>
                                <option value="3">{{ 'buyer.pedidos.filtro.situacao.opcoes.entregue' | translate}}</option>
                                <option value="4">{{ 'buyer.pedidos.filtro.situacao.opcoes.rejeitado' | translate}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-10">
                        <div class="input-group">
                            <span class="input-group-text"><i class="fa fa-search"></i></span>
                            <input type="text" maxlength="100" name="searchTerm" placeholder="{{ 'buyer.pedidos.historico.placeholder' | translate}}" class="form-control" [(ngModel)]="searchTerm" />
                            <button type="submit" [disabled]="(searchTerm?.length < 2) ? 'disabled' : null" class="btn btn-primary input-group-text" (click)="filtrar(0)">{{ 'buyer.pedidos.historico.botao' | translate}}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="card-body">
            <ng-scrollbar>
                @if (agrupamentosFiltrados?.length <= 0) {
                    <h3 class="vazio">
                        {{ (ja_pesquisou ? 'buyer.pedidos.historico.vazio.pos-pesquisa' : 'buyer.pedidos.historico.vazio.inicial') | translate}}
                    </h3>
                } @else {
                    <div ngbAccordion accordion="NgbAccordion" class="ngbAccordion" [closeOthers]="true">
                        @for (agrupamento of agrupamentosFiltrados; track agrupamento; let i = $index) {
                            <div ngbAccordionItem [destroyOnHide]="true">
                                <div ngbAccordionHeader>
                                    <button ngbAccordionButton class="btn btn-sm ml-2" (click)="toggleAgrupamento(agrupamento, i)">
                                        <i class="fa" [ngClass]="i == activeAccordionItemIndex ? 'fa-minus' : 'fa-plus'"></i>
                                        <span>
                                            <div>
                                                <i class="float-start media-box-object rounded-circle marca {{agrupamento?.marca}}"></i><span>{{agrupamento?.veiculo}} - {{'geral.pedido.codigo' | translate}}{{ agrupamento?.transaction_id }}</span>
                                            </div>
                                            <div class="chassi">
                                                <b>{{'buyer.dados-pedido.itens.cabecalho.chassi' | translate}}</b>{{agrupamento?.chassi_formatado}}
                                            </div>
                                        </span>
                                    </button>
                                    <div class="refresh" (click)="atualizarPedidoSelecionado({ quotation_id: agrupamento?.transaction_id })">
                                        <i class="fa fa-refresh text-tertiary float-end"></i>
                                    </div>
                                    <ngx-loading [show]="agrupamento.loading_pedido" [template]="templatePedido"></ngx-loading>
                                </div>
                                <div ngbAccordionCollapse>
                                    <div ngbAccordionBody>
                                        <ng-template>
                                            <hr />
                                            <app-dados-pedido [agrupamento]="agrupamento" [deliveryTimes]="deliveryTimes" [feriados]="feriados" [voltarHome]="false" [esconderRefresh]="true" (atualizarPedido)="atualizarPedidoSelecionado($event)"></app-dados-pedido>
                                            <ngx-loading [show]="agrupamento.loading_pedido" [template]="templatePedido"></ngx-loading>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </ng-scrollbar>
        </div>
    </div>
</div>

<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
<ng-template #templatePedido></ng-template>
